import { render, staticRenderFns } from "./ConsultaReclamacionesResult.vue?vue&type=template&id=35ae8b12&scoped=true"
import script from "./ConsultaReclamacionesResult.vue?vue&type=script&lang=ts"
export * from "./ConsultaReclamacionesResult.vue?vue&type=script&lang=ts"
import style0 from "./ConsultaReclamacionesResult.vue?vue&type=style&index=0&id=35ae8b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae8b12",
  null
  
)

export default component.exports